import axios from 'axios'
import router from '@/router'

export default {
  namespaced: true,

  state: {
    loaded: false,
    loading: false,
    items: []
  },

  mutations: {
    loaded_set(state, val) {
      state.loaded = val
    },

    loading_set(state, val) {
      state.loading = val
    },

    items_set(state, val) {
      state.items = val
    }
  },

  getters: {
    loading: state => !state.loaded,

    // получение элемента по ID, включая удалённые
    getItemByID: state => id => state.items.find(item => item.id === id),

    // не удалённые элементы
    items: state => state.items.filter(i => !i.isDeleted)
  },

  // В файле claimsStatuses.js
  actions: {
    async init({ commit, state }) {
      if (!state.loaded && !state.loading) {
        commit('loading_set', true)
        try {
          // Меняем на /directories
          const response = await axios.get('/directories')
          // И берем данные из поля ClaimsStatuses
          commit('items_set', response.data.claimsStatuses)
          commit('loaded_set', true)
        } catch {
          router.push('/error?message=Ошибка при загрузке статусов претензий')
        } finally {
          commit('loading_set', false)
        }
      }
    }
  }
}
